import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ComponentDesignSealTimestamps } from '@paragon/contract-library';

export interface ComponentDesignSealTimestampsState {
  readonly [componentDesignGuid: string]: ComponentDesignSealTimestamps | undefined;
}

const initialState: ComponentDesignSealTimestampsState = {};

export const componentDesignSealTimestampsSlice = createSlice({
  name: 'componentDesignSealTimestamps',
  initialState,
  reducers: {
    componentDesignSealTimestampsLoaded: (state, action: PayloadAction<readonly ComponentDesignSealTimestamps[]>) => {
      for (const componentDesignSealTimestamps of action.payload) {
        state[componentDesignSealTimestamps.componentDesignGuid] = componentDesignSealTimestamps;
      }
    },
  },
});

export const { componentDesignSealTimestampsLoaded } = componentDesignSealTimestampsSlice.actions;
export const componentDesignSealTimestamps = componentDesignSealTimestampsSlice.reducer;
